import { Artwork } from "kreate-common/modules/business-types";

import {
  formatInteger$Standard,
  formatLovelaceAmount$Compact,
  formatLovelaceAmount$Standard,
} from "@/modules/common-utils/format";

export function analyzeArtwork(artwork: Artwork) {
  const rules =
    artwork.mintingRules?.version === 1 ? artwork.mintingRules : undefined;

  return {
    stats: {
      price: {
        value: rules?.mintFee,
        text: formatLovelaceAmount$Compact(rules?.mintFee),
        tooltip: formatLovelaceAmount$Standard(rules?.mintFee),
      },
      minted: {
        value: {
          numMinted: rules?.numMinted,
          numEditions: rules?.numEditions,
        },
        text: [
          // we use `formatInteger$Standard` for this particular case
          formatInteger$Standard(rules?.numMinted),
          formatInteger$Standard(rules?.numEditions),
        ].join("/"),
        tooltip: [
          `Minted: ${formatInteger$Standard(rules?.numMinted)} Editions`,
          `Total: ${formatInteger$Standard(rules?.numEditions)} Editions`,
        ].join("\n"),
      },
      isSoldOut: rules && rules.numMinted === rules.numEditions,
    },
    constraints: {
      numMinting: {
        min: rules?.numMinting?.eq,
        max: rules?.numMinting?.eq,
      },
    },
  };
}

export const analyzeArtwork$MethodMintingRulesV1 = analyzeArtwork;
